import { EventEmitter } from '@angular/core';
import { TopicSegmentReport } from '../../../../models/measure/topic-segment-report';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { ReportSectionEnum } from '../../../../models/measure/report';
var TopicDrillDownComponent = /** @class */ (function () {
    function TopicDrillDownComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.changeSettingEvent = new EventEmitter();
        this.selectedTopics = [];
        this.hiddenTopics = [];
    }
    TopicDrillDownComponent.prototype.ngOnInit = function () {
        var _this = this;
        var activeTopics = this.allTopics.filter(function (topic) { return _this.topicSegmentReport.removeTopics.indexOf(topic.name) < 0; });
        var allTopicNames = this.allTopics.map(function (tp) { return tp.name; });
        this.hiddenTopics = this.topicSegmentReport.allTopicCharts.filter(function (tp) { return allTopicNames.indexOf(tp.name) < 0 && _this.topicSegmentReport.removeTopics.indexOf(tp.name) >= 0; })
            .map(function (topic) { return topic.name; });
        this.selectedTopics = activeTopics.map(function (topic) { return topic.id; });
    };
    TopicDrillDownComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(TopicDrillDownComponent.COMPONENT_NAME);
    };
    Object.defineProperty(TopicDrillDownComponent.prototype, "activeCharts", {
        get: function () {
            if (!this.topicSegmentReport) {
                return [];
            }
            var inActiveTopics = this.topicSegmentReport.removeTopics;
            return this.topicSegmentReport.allTopicCharts.filter(function (topic) { return inActiveTopics.indexOf(topic.name) < 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TopicDrillDownComponent.prototype, "allTopics", {
        get: function () {
            return this.topicSegmentReport ? this.topicSegmentReport.allTopics : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TopicDrillDownComponent.prototype, "topicChartColor", {
        get: function () {
            return this.userService.chartColors[0];
        },
        enumerable: true,
        configurable: true
    });
    TopicDrillDownComponent.prototype.filterTopics = function (evt) {
        var _this = this;
        var newInActiveTopics = this.allTopics.filter(function (topic) { return _this.selectedTopics.indexOf(topic.id) < 0; });
        this.topicSegmentReport.removeTopics = newInActiveTopics.map(function (topic) { return topic.name; });
        (_a = this.topicSegmentReport.removeTopics).push.apply(_a, this.hiddenTopics);
        this.changeSettingEvent.emit({
            reportType: ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT,
            value: this.topicSegmentReport.removeTopics
        });
        var _a;
    };
    Object.defineProperty(TopicDrillDownComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TopicDrillDownComponent.prototype, "haveNoData", {
        get: function () {
            return this.topicSegmentReport && this.activeCharts.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    TopicDrillDownComponent.COMPONENT_NAME = 'TopicDrillDownComponent';
    return TopicDrillDownComponent;
}());
export { TopicDrillDownComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/topic-drill-down/topic-drill-down.component.ts.pre-build-optimizer.js